export default __webpack_public_path__ + "static/media/Nozzle, Yellow.1c07a0da.png";